/* eslint-disable no-restricted-syntax */
/* eslint-disable no-loop-func */
import React from 'react';
import { Alert, AlertIcon } from '@stockx/ui';
import type { IronApiError } from '@app/types';

/**
 * Render an error block with react.
 *
 * @param Error object returned from ironLegacyClient.
 *
 * @return React Element
 */

function renderError(error: IronApiError<Dict>) {
  if (!error) {
    return;
  }

  const messages: JSX.Element[] = [];
  if (error?.messages) {
    let j = 0;
    for (const property in error.messages) {
      j += 1;
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      error.messages[property].forEach((message, i) => {
        messages.push(<li key={`${j}.${i}`}>{message}</li>);
      });
    }
  }

  return (
    <Alert variant="error">
      <>
        <AlertIcon />
        {error?.description || error}
        {messages}
      </>
    </Alert>
  );
}

export default renderError;
